var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sb_button",class:{
    'v_icon-only': _vm.iconOnly,
    s_loading: _vm.loading,
    s_pulsating: _vm.pulsating,
  },attrs:{"button-type":_vm.buttonType,"disabled":_vm.disabled},on:{"click":function($event){!_vm.disabled && _vm.$emit('click')}}},[_c('span',{staticClass:"sb_button_wrapper",style:({ opacity: _vm.loading ? 0.5 : 1 })},[(_vm.loading)?_c('LoadingSpinner',{attrs:{"size":'27.2px',"color":_vm.buttonType === 'primary' || _vm.buttonType === 'secondary'
          ? '#fff'
          : ' #040009'}}):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }